import messages from 'locale/messages.pt';

export class MessagesUtil {
  static get(key: string, ...params: any[]): string {
    let mensagem: string = messages[key] || `{ Mensagem não encontrada para '${key}' }`;

    params.forEach((param, index) => {
      mensagem = mensagem.replace(new RegExp(`\\{${index}\\}`, 'g'), param);
    });

    return mensagem;
  }
}
